/* eslint-disable react/no-array-index-key */
import { Flex, Pane, Text } from '@leverege/ui-elements'
import { Group } from '@visx/group'
import { ParentSize } from '@visx/responsive'
import { scaleOrdinal } from '@visx/scale'
import { Pie } from '@visx/shape'
import React, { useMemo } from 'react'
import S from '../Alerts.css'
import getPercentLegend from '../helpers/getPercentLegend'
import getReadableLabel from '../helpers/getReadableLabel'
import ChartLegend from './ChartLegend'

export default function AlertsDonutChart( props ) {
  const { result } = props
  const {
    counts : { perType },
  } = result

  return (
    <Pane variant="cardNoPad" layout="flex:col" className={S.chart1}>
      <div
        style={{
          height : '60px',
          padding : 'var(--size-padLarge)',
          borderBottom : '1px solid var(--color-base100)',
        }}>
        <Text variant="subtitle">Alerts By Category</Text>
      </div>
      <div
        style={{
          height : 'calc(100% - 60px)',
          padding :
            '0 var(--size-padLarge) 0 0',
        }}>
        <ParentSize
          parentSizeStyles={{
            overflow : 'hidden',
            width : '100%',
            height : '100%',
            position : 'relative',
          }}>
          {( { width, height } ) => (
            <Flex direction="row" justify="center" align="center" style={{ width }}>
              <DonutChart width={width} height={height} perType={perType} />
              <ChartLegend perType={perType}/>
            </Flex>
          )}
        </ParentSize>
      </div>
    </Pane>
  )
}

const frequency = d => d.frequency

const defaultMargin = { top : 20, right : 20, bottom : 20, left : 20 }

function DonutChart( { width, height, margin = defaultMargin, perType } ) {
  const innerWidth = ( width - 151 - margin.left - margin.right ) / 1.2
  const innerHeight = height - margin.top - margin.bottom
  const radius = Math.min( innerWidth, innerHeight ) / 2.2
  const centerY = innerHeight / 2
  const centerX = innerWidth / 2
  const top = centerY + margin.top
  const left = centerX + margin.left
  const pieSortValues = ( a, b ) => b - a

  const mappedData = useMemo( () => {
    return Object.entries( perType ?? {} ).map( ( [ k, v ] ) => {
      return {
        id : k,
        label : getReadableLabel( k ),
        percentage : getPercentLegend( perType, v ),
        frequency : v
      }
    } )
  }, [ perType ] )

  const getLetterFrequencyColor = useMemo( () => {
    return scaleOrdinal( {
      domain : mappedData.map( obj => obj.id ),
      range : [ '#FA5E7B', '#63C6C9' ],
    } )
  }, [ mappedData ] )

  return (
    <svg height={height} width="65%">
      <Group top={top} left={left}>
        <Pie
          data={mappedData}
          pieValue={frequency}
          pieSortValues={pieSortValues}
          outerRadius={radius}
          innerRadius={radius - 50}>
          {( pie ) => {
            return pie.arcs.map( ( arc, index ) => {
              const { id } = arc.data
              const arcPath = pie.path( arc )
              const arcFill = getLetterFrequencyColor( id )
              return (
                <g key={`arc-${id}-${index}`}>
                  <path d={arcPath} fill={arcFill} />
                </g>
              )
            } )
          }}
        </Pie>
      </Group>
    </svg>
  )
}
